<template>
    <div>
        {{ error }}
        <h2>{{ artist.name }}</h2>        
        <i>Version: {{ artist.version }}, Last update: {{ artist.updateDateTime | formatDate }}</i>
        <hr/>        
        <div class="md-form mt-0 row">                
                <button class="btn btn-info" type="submit" v-on:click="refresh">Refresh</button>
        </div>

        <form>
            <div class="row">
                <div class="col-sm-6 form-group">

                    <div class="form-group">
                        <label for="name" class="col-sm4 col-form-label">Name</label>
                        <div class="col-sm-8">
                            <input id="name" class="form-control" type="text" v-model="artist.name" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="bornYear" class="col-sm4 col-form-label">Born year</label>
                        <div class="col-sm-8">
                            <input id="bornYear" class="form-control" type="text" v-model="artist.bornYear" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="formedYear" class="col-sm4 col-form-label">Formed year</label>
                        <div class="col-sm-8">
                            <input id="formedYear" class="form-control" type="text" v-model="artist.formedYear" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="diedYear" class="col-sm4 col-form-label">Died year</label>
                        <div class="col-sm-8">
                            <input id="diedYear" class="form-control" type="text" v-model="artist.diedYear" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="disbanded" class="col-sm4 col-form-label">Disbanded</label>
                        <div class="col-sm-8">
                            <input id="disbanded" class="form-control" type="text" v-model="artist.disbanded" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="countryCode" class="col-sm4 col-form-label">Country code</label>
                        <div class="col-sm-8">
                            <input id="countryCode" class="form-control" type="text" v-model="artist.countryCode" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="gender" class="col-sm4 col-form-label">Gender</label>
                        <div class="col-sm-8">
                            <input id="gender" class="form-control" type="text" v-model="artist.gender" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="mood" class="col-sm4 col-form-label">Mood</label>
                        <div class="col-sm-8">
                            <input id="mood" class="form-control" type="text" v-model="artist.mood" />
                        </div>
                    </div>      
                    <div class="form-group">
                        <label for="style" class="col-sm4 col-form-label">Style</label>
                        <div class="col-sm-8">
                            <input id="style" class="form-control" type="text" v-model="artist.style" />
                        </div>
                    </div>
                    
                    <h3>Digital medias</h3>                  
                    <div class="form-group">
                        <label for="website" class="col-sm4 col-form-label">Website</label>
                        <div class="col-sm-8">
                            <input id="website" class="form-control" type="text" v-model="artist.website" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="wikipedia" class="col-sm4 col-form-label">Wikipedia</label>
                        <div class="col-sm-8">
                            <input id="wikipedia" class="form-control" type="text" v-model="artist.wikipedia" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="facebook" class="col-sm4 col-form-label">Facebook</label>
                        <div class="col-sm-8">
                            <input id="facebook" class="form-control" type="text" v-model="artist.facebook" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="twitter" class="col-sm4 col-form-label">Twitter</label>
                        <div class="col-sm-8">
                            <input id="twitter" class="form-control" type="text" v-model="artist.twitter" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="instagram" class="col-sm4 col-form-label">Instagram</label>
                        <div class="col-sm-8">
                            <input id="instagram" class="form-control" type="text" v-model="artist.instagram" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="allMusic" class="col-sm4 col-form-label">AllMusic</label>
                        <div class="col-sm-8">
                            <input id="allMusic" class="form-control" type="text" v-model="artist.allMusic" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="discogs" class="col-sm4 col-form-label">Discogs</label>
                        <div class="col-sm-8">
                            <input id="discogs" class="form-control" type="text" v-model="artist.discogs" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="bandsintown" class="col-sm4 col-form-label">Bandsintown</label>
                        <div class="col-sm-8">
                            <input id="bandsintown" class="form-control" type="text" v-model="artist.bandsintown" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="youtube" class="col-sm4 col-form-label">Youtube</label>
                        <div class="col-sm-8">
                            <input id="youtube" class="form-control" type="text" v-model="artist.youtube" />
                        </div>
                    </div>                    
                    <div class="form-group">
                        <label for="flickr" class="col-sm4 col-form-label">Flickr</label>
                        <div class="col-sm-8">
                            <input id="flickr" class="form-control" type="text" v-model="artist.flickr" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="lastFM" class="col-sm4 col-form-label">Last FM</label>
                        <div class="col-sm-8">
                            <input id="lastfm" class="form-control" type="text" v-model="artist.lastfm" />
                        </div>
                    </div>
                    
                    <h3>Biography</h3>                 
                    <div class="form-group">
                        <label for="biography" class="col-sm4 col-form-label">Biography</label>
                        <div class="col-sm-8">
                            <textarea id="biography" class="form-control" rows="6" v-model="artist.biography" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="biographyFR" class="col-sm4 col-form-label">Biography FR</label>
                        <div class="col-sm-8">
                            <textarea id="biographyFR" class="form-control" rows="6" v-model="artist.biographyFR" />
                        </div>
                    </div> 

                    <h3>IDs</h3>     
                    <div class="form-group">
                        <label for="musicBrainzArtistID" class="col-sm4 col-form-label"><a :href="'https://musicbrainz.org/artist/' + artist.musicBrainzID" target="_blank">MusicBrainz ID</a></label>
                        <div class="col-sm-8">
                            <input id="musicBrainzID" class="form-control" type="text" v-model="artist.musicBrainzID" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="audioDbID" class="col-sm4 col-form-label">AudioDb ID</label>
                        <div class="col-sm-8">
                            <input id="audioDbID" class="form-control" type="text" v-model="artist.audioDbID" />
                        </div>
                    </div>    
                </div>
                <div class="col-sm-6 form-group">
                    <h3>Pictures</h3>
                    <div class="form-group">
                        <label for="pictureUrl" class="col-sm4 col-form-label">Picture URL</label>
                        <div class="col-sm-4">                                                
                            <picture-input 
                                id="pictureInput"   
                                ref="pictureInput"       
                                @change="onChangePicture"
                                :prefill="pictureUrl"
                                :prefillOptions="{ fileName: 'picture.jpg', fileType: 'png', mediaType: 'image/jpg'}"
                                size=0
                                margin="16"                                                                 
                                button-class="btn btn-primary"
                                :custom-strings="{ drag: 'Drag a picture' }"
                                >                                
                            </picture-input>
                        </div>
                        <label for="fanartUrl" class="col-sm4 col-form-label">Fanart 1</label>
                        <div class="col-sm-4">     
                            <picture-input 
                                id="fanart1Input" 
                                ref="fanart1Input"   
                                @change="onChangePicture"
                                :prefill="fanart1Url"
                                :prefillOptions="{ fileName: 'fanart1.jpg', fileType: 'png', mediaType: 'image/jpg'}"
                                size=0                                      
                                margin="16"                                                                 
                                button-class="btn btn-primary"
                                :custom-strings="{ drag: 'Drag a picture' }"                                
                                >                                
                            </picture-input>               
                        </div>
                        <label for="fanartUrl2" v-if="artist.fanartUrl2 != 'undefined'" class="col-sm4 col-form-label">Fanart 2</label>
                        <div class="col-sm-4">
                            <picture-input 
                                id="fanart2Input"
                                ref="fanart2Input"
                                @change="onChangePicture"
                                :prefill="fanart2Url"
                                :prefillOptions="{ fileName: 'fanart2.jpg', fileType: 'png', mediaType: 'image/jpg'}"
                                size=0                                      
                                margin="16"                                                                 
                                button-class="btn btn-primary"
                                :custom-strings="{ drag: 'Drag a picture' }"                                
                                >                                
                            </picture-input>                                                 
                        </div>
                        <label for="fanartUrl3" class="col-sm4 col-form-label">Fanart 3</label>
                        <div class="col-sm-4">                    
                           <picture-input 
                                id="fanart3Input" 
                                ref="fanart3Input" 
                                @change="onChangePicture"
                                :prefill="fanart3Url"
                                :prefillOptions="{ fileName: 'fanart3.jpg', fileType: 'png', mediaType: 'image/jpg'}"
                                size=0                                      
                                margin="16"                                                                 
                                button-class="btn btn-primary"
                                :custom-strings="{ drag: 'Drag a picture' }"                                
                                ></picture-input>                        
                        </div>
                        <label for="logoUrl" class="col-sm4 col-form-label">Logo</label>
                        <div class="col-sm-4">                    
                            <picture-input 
                                id="logoInput" 
                                ref="logoInput" 
                                @change="onChangePicture"
                                :prefill="logoUrl"
                                :prefillOptions="{ fileName: 'logo.jpg', fileType: 'png', mediaType: 'image/jpg'}"
                                size=0                                      
                                margin="16"                                                                 
                                button-class="btn btn-primary"
                                :custom-strings="{ drag: 'Drag a picture' }"                                
                                ></picture-input>                  
                        </div>
                        <label for="bannerUrl" class="col-sm4 col-form-label">Banner</label>
                        <div class="col-sm-4">                    
                          <picture-input 
                                id="bannerInput" 
                                ref="bannerInput" 
                                @change="onChangePicture"
                                :prefill="bannerUrl"
                                :prefillOptions="{ fileName: 'logo.jpg', fileType: 'png', mediaType: 'image/jpg'}"
                                size=0                                      
                                margin="16"                                                                 
                                button-class="btn btn-primary"
                                :custom-strings="{ drag: 'Drag a picture' }"                                
                                ></picture-input>            
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    
    import ApiClient from '@/tools/apiClient.js';
    import PictureInput from '@/components/Picture-input.vue';

    let api = new ApiClient();

    export default {
        name: 'artist',            
        data: function () {
            return {
                artist: '',
                error: '',
                pictureUrl: '',
                fanart1Url: '',
                fanart2Url: '',
                fanart3Url: '',
                bannerUrl: '',
                logoUrl: ''
            }
        },
        components: {
          PictureInput  
        },

        created: async function () {
            
            let artistID = this.$route.params.id;

            this.artist = await api.getArtistAsync( artistID );
            this.pictureUrl = process.env.VUE_APP_API_BASE_URL + '/v2/artists/picture/' + this.artist.musicBrainzID + '/artists';
            this.fanart1Url = process.env.VUE_APP_API_BASE_URL + '/v2/artists/fanart/' + this.artist.musicBrainzID + '/0';
            this.fanart2Url = process.env.VUE_APP_API_BASE_URL + '/v2/artists/fanart/' + this.artist.musicBrainzID + '/1';
            this.fanart3Url = process.env.VUE_APP_API_BASE_URL + '/v2/artists/fanart/' + this.artist.musicBrainzID + '/2';
            this.bannerUrl = process.env.VUE_APP_API_BASE_URL + '/v2/artists/picture/' + this.artist.musicBrainzID + '/banners';
            this.logoUrl = process.env.VUE_APP_API_BASE_URL + '/v2/artists/picture/' + this.artist.musicBrainzID + '/logos';
        },
 
        methods: {            
            refresh: async function() {                                
                this.artist = await api.refreshArtistAsync( this.artist.musicBrainzID );                                
            },

            onError: function(error) {
             this.error = JSON.stringify(error);
            },
           
            onChangePicture: async function(sender) {

                if(sender == 'pictureInput')                 
                    await api.postPictureAsync(this.artist.musicBrainzID, 'artists', this.$refs.pictureInput.file);                
                else if( sender == 'fanart1Input')
                    await api.postPictureAsync(this.artist.musicBrainzID, 'fanarts', this.$refs.fanart1Input.file, 1);
                else if( sender == 'fanart2Input')
                    await api.postPictureAsync(this.artist.musicBrainzID, 'fanarts', this.$refs.fanart2Input.file, 2);
                else if( sender == 'fanart3Input')
                    await api.postPictureAsync(this.artist.musicBrainzID, 'fanarts', this.$refs.fanart3Input.file, 3);
                else if( sender == 'logoInput')
                    await api.postPictureAsync(this.artist.musicBrainzID, 'logos', this.$refs.logoInput.file);
                else if( sender == 'bannerInput')
                    await api.postPictureAsync(this.artist.musicBrainzID, 'banners', this.$refs.bannerInput.file);
            }            
        },
    }
</script>